// Who the family is on a registration form: a signed-in member (cookie) or a GUEST
// (no login — the random key below, kept per form in this browser). Every family
// call sends both; the server uses the login when there is one.
let guestToken = '';
const keyFor = (formId) => `ol.reg.guest.${formId}`;

export const regCfg = (extra = {}) => ({
  withCredentials: true, ...extra,
  headers: { ...(extra.headers || {}), ...(guestToken ? { 'X-Reg-Guest': guestToken } : {}) },
});
export const getGuest = () => guestToken;
export const loadGuest = (formId) => {
  try { guestToken = localStorage.getItem(keyFor(formId)) || ''; } catch { guestToken = ''; }
  return guestToken;
};
export const saveGuest = (formId, token) => {
  guestToken = token || '';
  try { if (token) localStorage.setItem(keyFor(formId), token); else localStorage.removeItem(keyFor(formId)); } catch { /* private mode */ }
};

// Phone photos are 3–12 MB. Send a 2000 px JPEG at high quality: the AI reader
// (Claude) itself works at ~1568 px on the long side, so nothing it reads is lost —
// but a 4 MB original would hit upload limits. Quality steps down only if needed
// to stay under `limit` bytes. PDFs and anything unreadable go as-is.
export const shrinkImage = async (file, max = 2000, limit = 950000) => {
  if (!file || !/^image\//.test(file.type) || file.size < limit) return file;
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const c = document.createElement('canvas');
    c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
    c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
    let blob = null;
    for (const q of [0.92, 0.85, 0.78, 0.7]) {
      blob = await new Promise(r => c.toBlob(r, 'image/jpeg', q));
      if (blob && blob.size <= limit) break;
    }
    if (!blob) return file;
    return new File([blob], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch { return file; }
};
export const uploadError = (e) => (e?.response?.status === 413
  ? 'That file is too large — take a photo instead, or use a smaller file.'
  : (e?.response?.data?.detail || 'Could not send the photo — try again.'));
